import type { LatLngBounds } from 'leaflet';

import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';
import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import * as actions from './actions';

export type FeaturesInBoundsState = {
  bounds: LatLngBounds;
  features: FeatureWithIDs[];
};

const state = createGenericFetchMachine<FeaturesInBoundsState>();

export { state, actions };
